<script>
import NxAuthLoginMethodButton
  from '@/modules/authentication/components/alternative-login-methods/AuthLoginMethodButton.vue';
import { LOGIN_PAGE_ID_LOGIN, LOGIN_PAGE_NAME } from '@/modules/authentication/config/login-routes';

export default {
  name: 'NxAuthUserPasswordLoginButton',
  components: { NxAuthLoginMethodButton },
  render(createElement) {
    return createElement(NxAuthLoginMethodButton, {
      attrs: {
        to: {
          name: LOGIN_PAGE_NAME,
          params: {
            page: LOGIN_PAGE_ID_LOGIN,
          },
        },
        icon: '$vuetify.icons.bCube',
        color: 'nx-brand white--text',
        title: this.$t('message.login.alternativeLoginMethods.bCubeCMS'),
      },
      on: {
        '!click': () => {
          this.$emit('redirect', LOGIN_PAGE_ID_LOGIN);
        },
      },
    });
  },

};
</script>
